module.exports = __webpack_public_path__ + "catalog/items/kitchen/Sink-with-drainer/Sink-with-drainer.svg";